// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_USER_SHIFTS_REQUESTS_SUCCESS = 'GET_USER_SHIFTS_REQUESTS_SUCCESS';
const GET_USER_SHIFT_REQUESTS_SUCCESS = 'GET_USER_SHIFT_REQUESTS_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestUserShiftsSuccess(payload) {
  return {
    type: GET_USER_SHIFTS_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestUserShiftSuccess(payload) {
  return {
    type: GET_USER_SHIFT_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} data
 * @param {function} callback
 * @return {Function}
 */
export function getRequestUserShifts(data = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.post(`/ta/user/shift`, {data})
      .then((r) => {
        dispatch(_getRequestUserShiftsSuccess(r));
        callback(r);
      })
      .catch((e) => {
        callback(undefined);
      });
  };
}/**
 * @param {object} data
 * @param {function} callback
 * @return {Function}
 */
export function getRequestUserPersonnelShifts(data = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.post(`/ta/personnel_id/shift`, {data})
      .then((r) => {
        dispatch(_getRequestUserShiftsSuccess(r));
        callback(r);
      })
      .catch((e) => {
        callback(undefined);
      });
  };
}/**
 * @param {number} userShiftsId
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestUserShift(userShiftsId, params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/ta/working_hours/${userShiftsId}`, {params})
      .then((r) => {
        dispatch(_getRequestUserShiftSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestUserShifts() {
  return _getRequestUserShiftsSuccess({data: {workingHours: []}, meta: {}});
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestUserShift() {
  return _getRequestUserShiftSuccess({data: {workingHours: {}}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  userShifts: [],
  userShift: {},
}, action) {
  switch (action.type) {
    case GET_USER_SHIFTS_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        userShifts: action.payload.workingHours,
      });
    case GET_USER_SHIFT_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        userShift: action.payload.workingHour,
      });
    default:
      return state;
  }
}
